import { createContext } from 'react';
import type { MastodonServerInfo } from '../types';

export interface ConnectionContextType {
  /** API 서버 연결 상태 */
  isOnline: boolean;
  /** 연결 테스트 중 여부 */
  isChecking: boolean;
  /** 클라이언트 업데이트 필요 여부 */
  needsUpdate: boolean;
  /** X 로그인 활성화 여부 */
  xLoginEnabled: boolean;
  /** Mastodon 로그인 활성화 여부 */
  mastodonLoginEnabled: boolean;
  /** 구성된 Mastodon 서버 목록 */
  mastodonServers: MastodonServerInfo[];
  /** Turnstile 활성화 여부 */
  turnstileEnabled: boolean;
  /** Turnstile 사이트 키 */
  turnstileSiteKey: string;
  /** 연결 재시도 */
  retry: () => void;
}

export const ConnectionContext = createContext<ConnectionContextType | null>(null);
